export default {"id":"03f8985e","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}